export default __webpack_public_path__ + "pdfs/ПРИМЕР ПРОЕКТА.pdf";